import React from 'react'

import { BROWSE_TEXT_ID } from 'experiments/pen-5015_v1_contextual_browse/components/BrowseText'

import { DisableHtmlTagScroll } from './DisableHtmlTagScroll'

const MOBILE_DROPDOWN_OFFSET = 20

export const MobileDropdown = ({
  children: dropdownContent,
}: {
  children: React.ReactNode
}) => {
  let distanceFromTop = 55
  let browseTextHeight = 0

  const browseText = document?.getElementById(BROWSE_TEXT_ID)

  if (browseText) {
    distanceFromTop = browseText.getBoundingClientRect().top + window.scrollY
    browseTextHeight = browseText?.offsetHeight || 0
  }

  return (
    <div
      style={{
        top: distanceFromTop + browseTextHeight + MOBILE_DROPDOWN_OFFSET,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        backgroundColor: 'var(--mc-theme-background)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DisableHtmlTagScroll />
      {dropdownContent}
    </div>
  )
}
